import { useEffect } from 'react'
import { toast } from 'react-toastify'

import { SerializedError } from '@reduxjs/toolkit'
import { FetchBaseQueryError } from '@reduxjs/toolkit/query'
export const useHandleError = ({
  isError,
  error,
}: {
  isError: boolean
  error: FetchBaseQueryError | SerializedError | undefined
}) => {
  useEffect(() => {
    if (isError && error && 'data' in error) {
      toast.error((error.data as any)?.message || 'Произошла ошибка')
    }
  }, [isError, error])
}
